// src/services/integration.service.js
import axios from 'axios';
import { auth } from './firebase';

const api = axios.create({
  baseURL: '/api',
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class IntegrationService {
  static async validateActiveCampaign(pixelId, credentials) {
    try {
      const response = await api.post(
        `/pixels/${pixelId}/integrations/activecampaign/validate`,
        credentials,
      );
      return response.data;
    } catch (error) {
      console.error('Error validating Active Campaign credentials:', error);
      throw error;
    }
  }

  static async setupActiveCampaign(pixelId, credentials) {
    try {
      const response = await api.post(
        `/pixels/${pixelId}/integrations/activecampaign`,
        credentials,
      );
      return response.data;
    } catch (error) {
      console.error('Error setting up Active Campaign integration:', error);
      throw error;
    }
  }

  static async removeActiveCampaign(pixelId) {
    try {
      const response = await api.delete(
        `/pixels/${pixelId}/integrations/activecampaign`,
      );
      return response.data;
    } catch (error) {
      console.error('Error removing Active Campaign integration:', error);
      throw error;
    }
  }

  // Add methods for other CRM integrations as they become available
}
